import httpAuth from '@/services/httpAuth'
import { serialize } from '@/services/object'

export async function list (filtros) {
  return httpAuth.get(`/pessoa?${serialize(filtros)}`, { tela: 'pessoa' })
}

export async function get (id) {
  return httpAuth.get(`/pessoa/${id}`, { tela: 'pessoa' })
}

export async function add (dados) {
  return httpAuth.post(`/pessoa`, dados, { funcionalidade: 'pessoa_incluir' })
}

export async function edit (id, dados) {
  return httpAuth.put(`/pessoa/${id}`, dados, { funcionalidade: 'pessoa_editar' })
}

export async function del (id) {
  return httpAuth.delete(`/pessoa/${id}`, { funcionalidade: 'pessoa_excluir' })
}
